import { motion } from "framer-motion";

interface WalkthroughOverlayProps {
  targetRect: DOMRect | null;
  onClose: () => void;
}

const PADDING = 8;
const BORDER_RADIUS = 12;

export function WalkthroughOverlay({ targetRect, onClose }: WalkthroughOverlayProps) {
  // No spotlight when there's no target (centered modal step)
  if (!targetRect) {
    return (
      <div
        className="fixed inset-0 z-[60] bg-black/50"
        onClick={onClose}
      />
    );
  }

  const cutout = {
    x: targetRect.x - PADDING,
    y: targetRect.y - PADDING,
    width: targetRect.width + PADDING * 2,
    height: targetRect.height + PADDING * 2,
  };

  return (
    <div className="fixed inset-0 z-[60] pointer-events-none">
      <svg className="absolute inset-0 w-full h-full">
        <defs>
          <mask id="walkthrough-mask">
            <rect width="100%" height="100%" fill="white" />
            <motion.rect
              fill="black"
              rx={BORDER_RADIUS}
              ry={BORDER_RADIUS}
              animate={cutout}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
            />
          </mask>
        </defs>
        <rect
          width="100%"
          height="100%"
          fill="rgba(0,0,0,0.5)"
          mask="url(#walkthrough-mask)"
          className="pointer-events-auto cursor-pointer"
          onClick={onClose}
        />
      </svg>
    </div>
  );
}
